<template>
  <div class="relative isolate w-full overflow-hidden bg-white">
    <shape-trame />

    <nuxt-img
      v-if="image"
      :src="image"
      :alt="imageAlt"
      :sizes="sizes"
      loading="lazy"
      class="absolute inset-0 size-full object-cover"
    />

    <icon
      v-else-if="iconName"
      :name="iconName"
      aria-hidden="true"
      class="absolute right-6 top-6 size-16 text-brand-500/80"
    />

    <shape-spotlight-media />

    <slot />
  </div>
</template>

<script setup lang="ts">
import type { CardMediaProps } from 'types/section'

defineProps<CardMediaProps>()
</script>
